import { Component, OnInit } from '@angular/core'
import { HouseholdProfilesService } from '@se-po/shared-data-access-services'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

const exampleHtml = `
<se-po-persona-avatar
  [persona]="persona">
</se-po-persona-avatar>
<button (click)="modal.open(personaId)">Upload Persona Image</button>
<se-po-persona-image-modal #modal (personaEdited)="onPersonaEdit($event)"></se-po-persona-image-modal>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { HouseholdProfilesService } from '@se-po/shared-data-access-services'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

export class PersonaImageModalExampleComponent implements OnInit {
  public persona: Persona
  public personaId = 87282325

  constructor(
    public householdProfilesService: HouseholdProfilesService
  ) {
  }

  public ngOnInit(): void {
    this.getPersona()
  }

  public onPersonaEdit(id: number): void {
    this.getPersona()
  }

  public getPersona(): void {
    this.householdProfilesService.find(this.personaId).subscribe(result => {
      this.persona = result.persona
    })
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-image-modal-example',
  template,
  styleUrls: ['./persona-image-modal-docs.component.scss'],
  standalone: false,
})
export class PersonaImageModalExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona
  public personaId = 87282325

  constructor(
    public householdProfilesService: HouseholdProfilesService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.getPersona()
  }

  public onPersonaEdit(id: number): void {
    this.getPersona()
  }

  public getPersona(): void {
    this.householdProfilesService.find(this.personaId).subscribe(result => {
      this.persona = result.persona
    })
  }
}
